module.exports = __webpack_public_path__ + "static/media/cryptocurrency-01.def828d5.svg";